
import { useSearchParams } from "react-router-dom";
import {Row, Col, Drawer} from 'antd';
import React, { useEffect } from "react";
import RoleAccess from "../cmp/role/Access";
import RoleList from "../cmp/role/List";
import RoleMembers from "../cmp/role/Members";
import Helper from "../func";
const RolePage = () => {
    const [searchParams, setSearchParams] = useSearchParams()
    const [memberRole, setMemberRole] = React.useState(null)
    const roleId = searchParams.get('id')

    const roleList = <RoleList
        msgTopic="role_page"
        onClickAuth={(v)=>{setSearchParams('?id='+v,{replace:true})}}
        onClickMembers={(v, role)=>setMemberRole(role)}
    />

    const memberDrawer = <Drawer
        title="权限组成员"
        width={Helper.isM() ? '100%' : 760}
        visible={!!memberRole}
        destroyOnClose
        onClose={()=>setMemberRole(null)}
    >
        {memberRole && <RoleMembers roleId={memberRole.role_id} roleName={memberRole.role_name}/>}
    </Drawer>

    const onEffect=()=>{}

    useEffect(onEffect,[]);
    if(Helper.isM()){
        return (
            <>
                {roleList}
               <Drawer visible={roleId>0} onClose={()=>setSearchParams('?id=0',{replace:true})}>
                   <RoleAccess roleId={roleId} msgTopic="role_page" />
               </Drawer>
               {memberDrawer}
            </>
        );
    }else{
        return (
            <>
                <Row justify="center" gutter={24} align="top" style={{height:"100%","alignItems":"stretch"}}>
                    <Col span={12} style={{borderRight:"1px solid #f0f0f0"}}>
                        {roleList}
                    </Col>
                    <Col span={12}><RoleAccess roleId={roleId} msgTopic="role_page" /></Col>
                </Row>
                {memberDrawer}
            </>
        );
    }
};

export default RolePage;
